import { Injectable } from '@angular/core';
import { retry, map, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SharedService } from '../shared.service';
import { IEvFieldUsage } from '../../interfaces/enrollment/ev-field-usage';
import { IEnrollmentVerificationResponse }  from '../../interfaces/enrollment/enrollment-verification-response';

@Injectable({
  providedIn: 'root'
})
export class EnrollmentVerificationService {


  // private brandConfigPropertiesUrl: string = '/config-props-admin/brands/{brandCode}/brand-config-properties';
  // private brandLogoImageUrl: string = '/image-admin/brands/{brandCode}/logo';
  // private csrConfigurationUrl: string = '/brands/{brandCode}/csr/config';
  // private csrAccountLookupUrl: string = '/brands/{brandCode}/csr/{accountNumber}';
  // private enrollmentVerificationConfigUrl: string = '/admin/brandconfig/{brandCode}/evp';
  // private offerFieldsUrl = '/field-admin/brands/{brandCode}/offers/{offerId}/fields';
  private readonly evConfigPropertiesUrl = '/ui-pages/brand-info/ev-props';
  private readonly evFieldsUrl = '/ui-pages/ev/fields';
  private readonly evRequestUrl = "/ui-pages/ev";

  private readonly baseHeaders = new HttpHeaders()
    .set("request-origin", "csr-portal");

  constructor(
    private readonly http: HttpClient,       
    private readonly sharedService: SharedService  
  ) { }

  // Get specific for EV process brand config properties
  public getEvConfigProperties(region: string, sessionId: string): Observable<Map<string, string>> {
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.evConfigPropertiesUrl;
    let headers = new HttpHeaders()
      .set("request-origin", "csr-portal")
      .set('session-id', sessionId);
    return this.http.get<any>(url, {headers: headers, responseType: 'json'})
    .pipe(
        map(response => {
        // const resultMap = new Map<string, string>();
        // for (const key in response) {
        //   if (response.hasOwnProperty(key)) {
        //     resultMap.set(key, String(response[key]));
        //   }
        // }
        // return resultMap;
          return new Map<string, string>(
            Object.entries(response)
          );
      }),
      catchError(this.sharedService.handleError)
    )
  }  

  // Get a list of EV fields for a specific combination of brandCode and channel, which are identified by sessionId
  public getEvFields(region: string, sessionId: string): Observable<IEvFieldUsage[]> {
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.evFieldsUrl;
    let headers = new HttpHeaders()
      .set("request-origin", "csr-portal")
      .set('session-id', sessionId);
    return this.http.get<IEvFieldUsage[]>(url, {headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }  

  // Submit a request with a set of customer credentials for Enrollment Verification
  public sendEvRequest(region: string, sessionId: string,  evMap: Map<string, any>): Observable<IEnrollmentVerificationResponse> {
    let headers = new HttpHeaders()
    .set("request-origin", "csr-portal")
    .set('session-id', sessionId);      
    let url = this.sharedService.getBaseUrlByRegion(region) + this.evRequestUrl;
    const body = Object.fromEntries(evMap);
    return this.http.post<any>(url, body, {headers: headers, responseType: 'json'})
    .pipe(
        map(response => {
          console.log('sendEvRequest service - response', response);
          let res: IEnrollmentVerificationResponse = {
            status: response.status,
            returnCode: response.returnCode,
            returnMessage: response.returnMessage,
            additionalInfo: new Map<string, string>(Object.entries(response.additionalInfo ?? {})) 
          };
          return res;
      }),
      catchError(this.sharedService.handleError)
    );
  }  

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }

}


  // getBrandConfigProperties(baseUrl: string, brandCode: string): Observable<IBrandConfigPropertyResponse> {
  //   var url = baseUrl + this.brandConfigPropertiesUrl.replace('{brandCode}', brandCode);
  //   var params = new HttpParams();
  //   params = params.set('enabled', 'true');
  //   params = params.set('limit', '100');
  //   return this.http.get<IBrandConfigPropertyResponse>(url, {params: params, headers: this.baseHeaders, responseType: 'json'})
  //   .pipe(
  //     catchError(this.handleError)
  //   )
  // }

  // getBrandLogoImage(brandCode: string, baseUrl: string): Observable<IBrandImage> {
  //   var url = baseUrl + this.brandLogoImageUrl.replace('{brandCode}', brandCode);
  //   return this.http.get<IBrandImage>(url, {headers: this.baseHeaders, responseType: 'json'})
  //   .pipe(
  //     catchError(this.handleError)
  //   )
  // }

  // getCsrConfiguration(brandCode: string, baseUrl: string): Observable<ICsrConfiguration> {
  //   var url = baseUrl + this.csrConfigurationUrl.replace('{brandCode}', brandCode);
  //   return this.http.get<ICsrConfiguration>(url, {headers: this.baseHeaders, responseType: 'json'})
  //   .pipe(
  //     catchError(this.handleError)
  //   )
  // }  

  // getCsrAccountLookup(brandCode: string, baseUrl: string, accountNumber: string, secondaryAccountId: string): Observable<ICsrAccountDetails> {
  //   var url = baseUrl + this.csrAccountLookupUrl.replace('{brandCode}', brandCode).replace('{accountNumber}',accountNumber);
  //   if (secondaryAccountId) {
  //     url += '?secAcct=' + secondaryAccountId;
  //   }
  //   return this.http.get<ICsrAccountDetails>(url, {headers: this.baseHeaders, responseType: 'json'})
  //   .pipe(
  //     catchError(this.handleError)
  //   )
  // }

  // getEnrollmentVerificationConfig(brandCode: string, baseUrl: string): Observable<IEnrollmentVerificationConfig> {
  //   var url = baseUrl + this.enrollmentVerificationConfigUrl.replace('{brandCode}', brandCode);
  //   return this.http.get<IEnrollmentVerificationConfig>(url, {headers: this.baseHeaders, responseType: 'json'})
  //   .pipe(
  //     catchError(this.handleError)
  //   )
  // }

  // getOfferFields(region: string, brandCode: string, offerId: number): Observable<IOfferField[]> {
  //   var url = this.sharedService.getBaseUrlByRegion(region) + this.offerFieldsUrl
  //     .replace('{brandCode}', brandCode)
  //     .replace('{offerId}', offerId.toString());
  //   return this.http.get<IOfferField[]>(url, {responseType: 'json'})
  //   .pipe(
  //     catchError(this.handleError)
  //   )
  // }
